import { v4 as uuidv4 } from 'uuid';
import { ImportMarketingContractContent } from '../view/importMarketingContractContent';


export const ImportMarketContractTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Импорт маркетингового договора',
        view: {
            content: <ImportMarketingContractContent plugin={'import_market_contract_plugin'} />
        }
    }
}
